import { render, staticRenderFns } from "./Factory-registration.vue?vue&type=template&id=5b47c06c&"
import script from "./Factory-registration.vue?vue&type=script&lang=js&"
export * from "./Factory-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports